export enum OverwriteType
{
     Undefined = 0,
     DoNothing = 1,         // Do not overwrite the property
     FillIfEmpty = 2,       // Fill the property only if it is empty
     OverwriteAlways = 3    // Overwrite the property regardless of its current value
}
